
<template>
	<div class="min-h-screen w-full bg-white relative">
        <slot />
	</div>
</template>
